// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

const appLogo = process.env.VUE_APP_LOGO || 'logo.png'

const logoMap = {
  'logo.png': require('@/assets/images/logo/logo.png'),
  'logo.svg': require('@/assets/images/logo/logo.svg'),
  'logo-arasana.png': require('@/assets/images/logo/logo-arasana.png'),
  'logo-2.png': require('@/assets/images/logo/logo-2.png'),
  'vuexy-logo.png': require('@/assets/images/logo/vuexy-logo.png'),
}

const getLogoImage = (logoName) => {
  if (logoName && logoMap[logoName]) {
    return logoMap[logoName]
  }
  return require('@/assets/images/logo/logo.png')
}

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: 'Vuexy', // Will update name in navigation menu (Branding)
    appLogoImage: getLogoImage(appLogo),
    appLogoImage2: require('@/assets/images/logo/logo-2.png'),
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark, boho-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: true,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'sticky', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: false,
    enableScrollToTop: false,
  },
}
